import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { NgxSpinnerService } from 'ngx-spinner';
import { PedidoRecebimento } from 'src/app/models/pedido-recebimento';
import { CarregandoService } from 'src/app/services/carregando.service';
import { GlobalService } from 'src/app/services/global.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PedidoRecebimentoService } from 'src/app/services/pedido-recebimento.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';

@Component({
  selector: 'app-cadastrar-pedido-recebimento-modal',
  templateUrl: './cadastrar-pedido-recebimento-modal.component.html',
  styleUrls: ['./cadastrar-pedido-recebimento-modal.component.scss']
})
export class CadastrarPedidoRecebimentoModalComponent implements OnInit {


  idPedidoRecebimento;
  idCupom;
  pedidoRecebimento: PedidoRecebimento;
  public config: PerfectScrollbarConfigInterface = {};
  administrador = false;
  carregando = true;
  editando = false;

  // construtor
  constructor(public dialogRef: MatDialogRef<CadastrarPedidoRecebimentoModalComponent>, private globalService: GlobalService,
    @Inject(MAT_DIALOG_DATA) public data: any, private notificacaoService: NotificacaoService, private pedidoRecebimentoService: PedidoRecebimentoService,
    private spinner: NgxSpinnerService, private utilitarioService: UtilitarioService, private carregandoService: CarregandoService,) {
    this.idPedidoRecebimento = data.idPedidoRecebimento;
    this.idCupom = data.idCupom;
  }

  async ngOnInit() {

    this.administrador = await this.globalService.administrador();
    if (this.idPedidoRecebimento) {
      this.editando = true;
      this.buscarPedidoRecebimento();
    } else {
      this.pedidoRecebimento = new PedidoRecebimento();
    }
  }

  salvar() {
    if (this.pedidoRecebimento.valor !== null && this.pedidoRecebimento.valor !== undefined) {
      this.pedidoRecebimento.valor = Number(this.pedidoRecebimento.valor);
    }

    this.pedidoRecebimento.idCupom = this.idCupom;

    this.carregandoService.mostra('salvarPedidoRecebimento');
    this.pedidoRecebimentoService.salvar(this.pedidoRecebimento).subscribe((retorno) => {
      this.notificacaoService.sucesso('Classificação salva com sucesso!!!');
      this.carregandoService.esconde('salvarPedidoRecebimento');
      this.dialogRef.close(true);
    }, (erro) => {
      this.carregandoService.esconde('salvarPedidoRecebimento');
      this.notificacaoService.erro(erro);
    });
  }


  fechar() {
    this.dialogRef.close();
  }

  buscarPedidoRecebimento() {
    this.carregandoService.mostra('buscarPedidoRecebimento');

    this.pedidoRecebimentoService.consultarPorId(this.idPedidoRecebimento).subscribe((data: any) => {
      this.pedidoRecebimento = data;
      this.carregando = false;
      this.carregandoService.esconde('buscarPedidoRecebimento');
    }, (erro) => {
      this.carregandoService.esconde('buscarPedidoRecebimento');
      this.notificacaoService.erro(erro);
    });
  }

  validar() {
    return this.pedidoRecebimento.valor !== null && this.pedidoRecebimento.valor !== undefined &&
    this.pedidoRecebimento.data !== null && this.pedidoRecebimento.data !== undefined;
  }

}
